module.exports = __webpack_public_path__ + "img/rec.69eaa9c2.svg";